//Plantilla de archivo API
let prefix = '/api/productionsLines';

function indexLines(data) {
    return window.axios.get(prefix + '/index', { params: data });
}
function storeLines(data) {
    return window.axios.post(prefix, data);
}
function updateLines(id, data) {
    return window.axios.patch(prefix + '/' + id, data);
}
function deleteLines(id) {
    return window.axios.delete(prefix + '/' + id);
}

export default {
    indexLines, storeLines, updateLines, deleteLines

}